import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  FACEBOOK_SOURCE_NAME,
  FORUM_PAGE_NAME_LABEL,
  SOCIAL_MEDIA_SOURCE_TYPE,
  CHECKED_CHECKBOX_CLASS,
  INDETERMINATE_CHECKBOX_CLASS,
  UNCHECKED_CHECKBOX_CLASS
} from '../../sources/redux/constants';
import { SOURCE_NAME_ALL_SOCIAL_MEDIA } from '../redux/constants';
import { t } from 'i18next';
import {
  FILTER_I18N_PREFIX as MY_I18N_PREFIX,
  FILTER_I18N_KEYS as MY_I18N_KEYS
} from './constants/i18n/Filteri18nConstants';

class Filter extends Component {
  static propTypes = {
      filterBySource: PropTypes.func.isRequired
  };
  
  constructor(props) {
    super(props);
    this.state = {
      allFilter: [],
      socialMedias: [],
      allSocialMedia: true,
      facebookCheckedStatus: UNCHECKED_CHECKBOX_CLASS,
      truescopeForumsCheckedStatus: UNCHECKED_CHECKBOX_CLASS,
      isFilterListActive: false,
      facebookPages: [],
      truescopeForums: [],
      nonFacebookOrTruescopeForumSources: [],
      showFacebookDropdown: false,
      showTruescopeForumDropdown: false
    };
    this.wrapperRef = React.createRef();
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (
      newProps.sourcesFilter.length &&
      JSON.stringify(this.state.allFilter) !== JSON.stringify(newProps.sourcesFilter)
    ) {
      this.setState({
        allFilter: JSON.parse(JSON.stringify(newProps.sourcesFilter)),
      });
      
      let socialMedias = newProps.sourcesFilter.filter(
        source => source.sourceType.toLowerCase() === SOCIAL_MEDIA_SOURCE_TYPE,
      );

      let facebookPages = newProps.sourcesFilter.filter(
        source => this._isSourceAFacebookPage(source.sourceName),
      );
      let truescopeForums = newProps.sourcesFilter.filter(
        source => this._isSourceATruescopeForum(source.sourceName),
      );
      let nonFacebookOrTruescopeForumSources = newProps.sourcesFilter.filter(
        source => !this._isSourceAFacebookSourceOrATruescopeForum(source.sourceName),
      );

      this._determineAndSetFacebookPagesAndFacebookCheckedStatus(facebookPages);
      this._determineAndSetTruescopeForumsAndTruescopeForumsCheckedStatus(truescopeForums);

      this.setState({
        socialMedias,
        nonFacebookOrTruescopeForumSources
      });
    }
  }

  getI18nText(textKey) {
    return t(MY_I18N_PREFIX + "." + textKey);
  }

  _isSourceAFacebookPage(sourceName) {
    return sourceName.toLowerCase().includes(FACEBOOK_SOURCE_NAME) && sourceName.toLowerCase() !== FACEBOOK_SOURCE_NAME;
  }

  _isSourceATruescopeForum(sourceName) {
    return sourceName.toLowerCase().includes(FORUM_PAGE_NAME_LABEL);
  }

  _isSourceAFacebookSourceOrATruescopeForum(sourceName) {
    return sourceName.toLowerCase().includes(FACEBOOK_SOURCE_NAME) || sourceName.toLowerCase().includes(FORUM_PAGE_NAME_LABEL)
  }

  handleClickOutside = event => {
    if (event && this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
      this.setState({
        isFilterListActive: false,
      });
    }
  };

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  checkAllSources = event => {
    const { 
      socialMedias,
      facebookPages,
      truescopeForums,
      nonFacebookOrTruescopeForumSources
    } = this.state;

    const updatedSocialMedias = socialMedias.map(media => {
      media.checked = event.target.checked;
      return media;
    });

    const updatedFacebookPages = facebookPages.map(media => {
      media.checked = event.target.checked;
      return media;
    });

    const updatedTruescopeForums = truescopeForums.map(media => {
      media.checked = event.target.checked;
      return media;
    });

    const updatedNonFacebookOrTruescopeForumSources = nonFacebookOrTruescopeForumSources.map(media => {
      media.checked = event.target.checked;
      return media;
    });

    this.setState(
      {
        socialMedias: [],
        facebookPages: [],
        truescopeForums: [],
        nonFacebookOrTruescopeForumSources: [],
        allSocialMedia: event.target.checked,
        facebookCheckedStatus: event.target.checked ? CHECKED_CHECKBOX_CLASS : UNCHECKED_CHECKBOX_CLASS,
        truescopeForumsCheckedStatus: event.target.checked ? CHECKED_CHECKBOX_CLASS : UNCHECKED_CHECKBOX_CLASS
      },
      () => {
        this.setState({
          socialMedias: updatedSocialMedias,
          facebookPages: updatedFacebookPages,
          truescopeForums: updatedTruescopeForums,
          nonFacebookOrTruescopeForumSources: updatedNonFacebookOrTruescopeForumSources
        });
      },
    );
    if (event.target.checked) {
      this.props.filterBySource([SOURCE_NAME_ALL_SOCIAL_MEDIA]);
    } else {
      this.props.filterBySource('');
    }
  };

  checkAllTruescopeForumSources = (_) => {

    let selectedSocialMedia = [];
    let updatedSocialMedias = [...this.state.socialMedias];
    let truescopeForums = [...this.state.truescopeForums];
    const newCheckedStatus = this._getNewCheckedStatusBasedOnPreviousCheckedStatus(this.state.truescopeForumsCheckedStatus);

    const isTruescopeMediaChecked = (newCheckedStatus === CHECKED_CHECKBOX_CLASS);

    const updatedTruescopeForums = truescopeForums.map(media => {
      return {
        ...media,
        checked: isTruescopeMediaChecked
      };
    });

    updatedSocialMedias = updatedSocialMedias.map(media => {
      if (this._isSourceATruescopeForum(media.sourceName)) {
        return {
          ...media,
          checked: isTruescopeMediaChecked
        };
      }
      return media;
    });

    updatedSocialMedias.forEach(media => {
      if (media.checked) selectedSocialMedia.push(media.sourceName);
    });
    const allSocialMedia = updatedSocialMedias.every(f => f.checked);
 
    this.setState({
      truescopeForums: updatedTruescopeForums,
      socialMedias: updatedSocialMedias,
      allSocialMedia: allSocialMedia,
      truescopeForumsCheckedStatus: newCheckedStatus
    }, () => {
      if (allSocialMedia) {
        this.props.filterBySource([SOURCE_NAME_ALL_SOCIAL_MEDIA]);
      } else {
        this.props.filterBySource([...selectedSocialMedia]);
    }
    });
  }

  checkAllFacebookPages = (_) => {

    let selectedSocialMedia = [];
    let updatedSocialMedias = [...this.state.socialMedias];
    let facebookPages = [...this.state.facebookPages];
    const newCheckedStatus = this._getNewCheckedStatusBasedOnPreviousCheckedStatus(this.state.facebookCheckedStatus);

    const isFacebookMediaChecked = (newCheckedStatus === CHECKED_CHECKBOX_CLASS);

    const updatedFacebookPages = facebookPages.map(media => {
      return {
        ...media,
        checked: isFacebookMediaChecked
      };
    });

    updatedSocialMedias = updatedSocialMedias.map(media => {
      if (this._isSourceAFacebookPage(media.sourceName)) {
        return {
          ...media,
          checked: isFacebookMediaChecked
        };
      }
      return media;
    });

    updatedSocialMedias.forEach(media => {
      if (media.checked) selectedSocialMedia.push(media.sourceName);
    });
    const allSocialMedia = updatedSocialMedias.every(f => f.checked);
 
    this.setState({
      facebookPages: updatedFacebookPages,
      socialMedias: updatedSocialMedias,
      allSocialMedia: allSocialMedia,
      facebookCheckedStatus: newCheckedStatus
    }, () => {
      if (allSocialMedia) {
        this.props.filterBySource([SOURCE_NAME_ALL_SOCIAL_MEDIA]);
      } else {
        this.props.filterBySource([...selectedSocialMedia]);
    }
    });
  }

  _getNewCheckedStatusBasedOnPreviousCheckedStatus(previousCheckedStatus) {
      if (previousCheckedStatus === UNCHECKED_CHECKBOX_CLASS || previousCheckedStatus === INDETERMINATE_CHECKBOX_CLASS) {
        return CHECKED_CHECKBOX_CLASS;
      }
      else {
        return UNCHECKED_CHECKBOX_CLASS;
      }
    }

  filterBySources = (source) => {
    const { socialMedias } = this.state;
    let facebookPagesToUpdate =  [...this.state.facebookPages];
    let truescopeForumsToUpdate =  [...this.state.truescopeForums];
    let otherSourcesToUpdate =  [...this.state.nonFacebookOrTruescopeForumSources];
    
    let allChecked = true;
    let selectedSocialMedia = [];
    let socialMediasToUpdate = socialMedias.map(media => {
      if (media.sourceName === source.sourceName) {
        media.checked = !media.checked;
      }
      
      if (media.checked) {
        selectedSocialMedia.push(media.sourceName);
      } else {
        allChecked = false;
      }
      return media;
    });
    this.setState({ socialMedias: socialMediasToUpdate, allSocialMedia: allChecked });

    if (this._isSourceAFacebookPage(source.sourceName)) {
      this._updateFacebookPagesCheckedStatus(source, facebookPagesToUpdate);
    }
    else if (this._isSourceATruescopeForum(source.sourceName)) {
      this._updateTruescopeForumsCheckedStatus(source, truescopeForumsToUpdate);
    }
    else {
      this._updateNonFacebookOrTruescopeForumSourcesCheckedStatus(source, otherSourcesToUpdate); 
    }

    let updatedFilter = [];
    if (allChecked) {
      updatedFilter = [SOURCE_NAME_ALL_SOCIAL_MEDIA];
    } else {
      updatedFilter = [...selectedSocialMedia];
    }

    this.props.filterBySource(updatedFilter);
  };


  _updateTruescopeForumsCheckedStatus(source, truescopeForumsToUpdate) {
    const updatedTruescopeForums = truescopeForumsToUpdate.map(media => {
      if (media.sourceName === source.sourceName) {
        return {
          ...media,
          checked: !media.checked
        };
      }
      return media;
    });
    this._determineAndSetTruescopeForumsAndTruescopeForumsCheckedStatus(updatedTruescopeForums);
  }

  _determineAndSetTruescopeForumsAndTruescopeForumsCheckedStatus(truescopeForumsToUpdate) {
    const allTruescopeForumsChecked = truescopeForumsToUpdate.every(f => f.checked);
    const atLeastOneTruescopeForumChecked = truescopeForumsToUpdate.some(f => f.checked);
    const truescopeForumsCheckedStatus = this._getCheckedStatusBasedOnSourcesInCategoryChecked(
      atLeastOneTruescopeForumChecked,
      allTruescopeForumsChecked
    );
    this.setState({ 
      truescopeForums: truescopeForumsToUpdate, 
      truescopeForumsCheckedStatus: truescopeForumsCheckedStatus 
    });
  }

  _updateFacebookPagesCheckedStatus(source, facebookPagesToUpdate) {
    const updatedFacebookPages = facebookPagesToUpdate.map(media => {
      if (media.sourceName === source.sourceName) {
        return {
          ...media,
          checked: !media.checked
        };
      }
      return media;
    });

    this._determineAndSetFacebookPagesAndFacebookCheckedStatus(updatedFacebookPages);
  }

  _determineAndSetFacebookPagesAndFacebookCheckedStatus(facebookPagesToUpdate) {
    const allFacebookPagesChecked = facebookPagesToUpdate.every(f => f.checked);
    const atLeastOneFacebookPageChecked = facebookPagesToUpdate.some(f => f.checked);
    const facebookCheckedStatus = this._getCheckedStatusBasedOnSourcesInCategoryChecked(
      atLeastOneFacebookPageChecked,
      allFacebookPagesChecked
    );
    this.setState({ 
      facebookPages: facebookPagesToUpdate, 
      facebookCheckedStatus: facebookCheckedStatus 
    });
  }

  _updateNonFacebookOrTruescopeForumSourcesCheckedStatus(source, otherSourcesToUpdate) {
    const updatedOtherSourcesMap = otherSourcesToUpdate.map(media => {
      if (media.sourceName === source.sourceName) {
        return {
          ...media,
          checked: !media.checked
        };
      }
      return media;
    });
    this.setState({ nonFacebookOrTruescopeForumSources: updatedOtherSourcesMap });  
  }

  _getCheckedStatusBasedOnSourcesInCategoryChecked(atLeastOneSourceChecked, allSourcesChecked) {
    if (allSourcesChecked) {
      return CHECKED_CHECKBOX_CLASS;
    }
    else if (atLeastOneSourceChecked) {
      return INDETERMINATE_CHECKBOX_CLASS;
    }
    else {
      return UNCHECKED_CHECKBOX_CLASS;
    }
  }

  toggleShowFacebookDropdown= () => {  
    this.setState(prevState => {
      return { showFacebookDropdown: !prevState.showFacebookDropdown };
    });
  }

  toggleShowTruescopeForumDropdown= () => {  
    this.setState(prevState => {
      return { showTruescopeForumDropdown: !prevState.showTruescopeForumDropdown };
    });
  }
  

  render() {
    let {
      isFilterListActive,
      socialMedias,
      allSocialMedia,
      facebookCheckedStatus,
      truescopeForumsCheckedStatus,
      facebookPages,
      truescopeForums,
      nonFacebookOrTruescopeForumSources,
      showFacebookDropdown,
      showTruescopeForumDropdown
    } = this.state;

    const sourceFilter = localStorage.getItem('dashboardFilter');
    if (sourceFilter) {
      const savedFilters = JSON.parse(sourceFilter)['source'];
      if (savedFilters) {
        facebookPages = facebookPages.map(
            media => {
                if (
                    savedFilters.indexOf(media.sourceName.toLowerCase()) !== -1 ||
                    savedFilters.indexOf(SOURCE_NAME_ALL_SOCIAL_MEDIA) !== -1
                ) {
                    media.checked = true;
                } else {
                    media.checked = false;
                }
                return media; 
            }
        )
        const atLeastOneFacebookPageChecked = facebookPages.some(f => f.checked);
        const allFacebookPagesChecked = facebookPages.every(f => f.checked);
        facebookCheckedStatus = this._getCheckedStatusBasedOnSourcesInCategoryChecked(
          atLeastOneFacebookPageChecked,
          allFacebookPagesChecked
        );

        truescopeForums = truescopeForums.map(
            media => {
                if (
                    savedFilters.indexOf(media.sourceName.toLowerCase()) !== -1 ||
                    savedFilters.indexOf(SOURCE_NAME_ALL_SOCIAL_MEDIA) !== -1
                ) {
                  media.checked = true;
                } else {
                    media.checked = false;
                }
                return media; 
            }
        )
        const atLeastOneTruescopeForumChecked = truescopeForums.some(f => f.checked);
        const allTruescopeForumsChecked = truescopeForums.every(f => f.checked);
        truescopeForumsCheckedStatus = this._getCheckedStatusBasedOnSourcesInCategoryChecked(
          atLeastOneTruescopeForumChecked,
          allTruescopeForumsChecked
        );

        socialMedias = socialMedias.map(media => {
          if (
            savedFilters.indexOf(media.sourceName.toLowerCase()) !== -1 ||
            savedFilters.indexOf(SOURCE_NAME_ALL_SOCIAL_MEDIA) !== -1
          ) {
            media.checked = true;
          } else {
            media.checked = false;
          }
          return media;
        });

        nonFacebookOrTruescopeForumSources = nonFacebookOrTruescopeForumSources.map(
            media => {
                if (
                    savedFilters.indexOf(media.sourceName.toLowerCase()) !== -1 ||
                    savedFilters.indexOf(SOURCE_NAME_ALL_SOCIAL_MEDIA) !== -1
                    || savedFilters.indexOf(FACEBOOK_SOURCE_NAME) !== -1
                ) {
                    media.checked = true;
                } else {
                    media.checked = false;
                }
                return media; 
            }
        )

        if (
          savedFilters.indexOf(SOURCE_NAME_ALL_SOCIAL_MEDIA) !== -1
        ) {
          allSocialMedia = true;
        } else {
          allSocialMedia = false;
        }
        allSocialMedia = savedFilters.indexOf(SOURCE_NAME_ALL_SOCIAL_MEDIA) !== -1;
      }
    }
    return (
      <div className="custom-filter-plugin" ref={this.wrapperRef}>
        <div
          className={`input-container ${isFilterListActive ? 'active' : ''}`}
          onClick={() =>
            this.setState(prevState => {
              return {
                isFilterListActive: !prevState.isFilterListActive,
              };
            })
          }
        >
          <i className="la la-filter icon" />
          <input type="text" placeholder="Sources" readOnly defaultValue=""></input>
        </div>
        <div className={`filter-container ${isFilterListActive ? 'show' : ''}`}>
          <div className="row">            
            {socialMedias.length > 0 && (
              <div className="col-12">
                <div className="select-item">
                  <input
                    className="styled-checkbox"
                    id="all_social_media"
                    type="checkbox"
                    value={SOURCE_NAME_ALL_SOCIAL_MEDIA}
                    readOnly
                    checked={allSocialMedia}
                    onChange={e => this.checkAllSources(e)}
                  />
                  <label htmlFor="all_social_media">{this.getI18nText(MY_I18N_KEYS.all_sources_label)}</label>
                </div>
              </div>
            )}

            {facebookPages.length > 0 && (<div style={{ width: '100%' }}>
                <div className="col-12">
                    <div className="select-item select-item-dropdown-header">
                        <input
                            className={`styled-checkbox ${facebookCheckedStatus}`}
                            id="facebook-header"
                            type="checkbox"
                            value="facebook"
                            onChange={e => this.checkAllFacebookPages(e)}
                        />
                        <label htmlFor="facebook-header">{this.getI18nText(MY_I18N_KEYS.facebook_category_label)}</label>
                        <button 
                            onClick={() => this.toggleShowFacebookDropdown()}
                            className="dropdown-button"
                        >
                            <i className={`la la-${showFacebookDropdown ? 'minus' :'plus'}`} />
                        </button>
                    </div>
                </div>
                {showFacebookDropdown && (
                    <div className="sources-nested-dropdown">
                    {facebookPages.map((source, index) => (
                        <div className="select-item select-item-dropdown-item" key={'facebook_' + index}>
                            <input
                            className="styled-checkbox"
                            id={'facebook_' + index}
                            type="checkbox"
                            readOnly
                            onChange={() => this.filterBySources(source)}
                            checked={source.checked}
                            value={source.sourceName}
                            />
                            <label htmlFor={'facebook_' + index}>{source.sourceName}</label>
                        </div>
                    ))}
                    </div>
                )}
            </div>)}

            {nonFacebookOrTruescopeForumSources.length > 0 && nonFacebookOrTruescopeForumSources.map((source, index) => (
                <div className="col-12" key={'othersources_' + index}>
                    <div className="select-item">
                        <input
                            className="styled-checkbox"
                            id={'othersources_' + index}
                            type="checkbox"
                            readOnly
                            onChange={() => this.filterBySources(source)}
                            checked={source.checked}
                            value={source.sourceName}
                        />
                        <label htmlFor={'othersources_' + index}>{source.sourceName}</label>
                    </div>
                </div>
            ))}

            {truescopeForums.length > 0 && (<div style={{ width: '100%' }}>
                <div className="col-12">
                    <div className="select-item select-item-dropdown-header">
                          <input
                              className={`styled-checkbox ${truescopeForumsCheckedStatus}`}
                              id="truescope-forums-header"
                              type="checkbox"
                              value=""
                              onChange={e => this.checkAllTruescopeForumSources(e)}
                          />
                          <label htmlFor="truescope-forums-header">{this.getI18nText(MY_I18N_KEYS.forums_category_label)}</label>
                        <button 
                            onClick={() => this.toggleShowTruescopeForumDropdown()}
                            className="dropdown-button"
                        >
                            <i className={`la la-${showTruescopeForumDropdown ? 'minus' :'plus'}`} />
                        </button>
                    </div>
                </div>
                {showTruescopeForumDropdown && (
                    <div className="sources-nested-dropdown">
                    {truescopeForums.map((source, index) => (
                        <div className="select-item select-item-dropdown-item" key={'forum_' + index}>
                            <input
                            className="styled-checkbox"
                            id={'forum_' + index}
                            type="checkbox"
                            readOnly
                            onChange={() => this.filterBySources(source)}
                            checked={source.checked}
                            value={source.sourceName}
                            />
                            <label htmlFor={'forum_' + index}>{source.sourceName}</label>
                        </div>
                    ))}
                    </div>
                )}
            </div>)}
          </div>
        </div>
      </div>
    );
  }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/features/home/components/Filter.js